module.exports = "/images/icon_favorite_active.svg?355502ca932ecb8d9e3167f671c050b7";